import { useEffect, useState, useRef, useContext } from "react";
import RefreshContext from "../RefreshContext";
import apiClient from "../lib/apiClient";

function dollarize(value) {
  const absValue = Math.abs(value);
  if (absValue >= 1000000) {
    return `$${(value / 1000000).toFixed(1)}M`;
  }
  if (absValue >= 1000) {
    return `$${(value / 1000).toFixed(0)}K`;
  }
  return `$${value.toFixed(0)}`;
}

export default function BarChart({ data, path, title, height = 300 }) {

  const [chartData, setChartData] = useState(data);
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const { refreshKey } = useContext(RefreshContext);

  useEffect(() => {
    const fetchChartData = async () => {
      apiClient.get(path)
        .then(({ data }) => {
          setChartData(data);
        }).catch(console.error);
    }
    if (data) {
      setChartData({ ...data })
    } else {
      fetchChartData();
    }
  }, [data, path, refreshKey]);

  useEffect(() => {
    if (chartData && chartRef.current) {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
      const ctx = chartRef.current.getContext("2d");
      chartInstance.current = new window.Chart(ctx, {
        type: "bar",
        data: chartData,
        options: {
          maintainAspectRatio: false,
          height: height,

          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function (value, index, values) {
                  return dollarize(value || 0);
                }
              }
            }
          },

        }
      });
    }
  }, [chartData, chartRef, height, refreshKey]);

  return (
    <div className={"mb-2 mt-2"}>
      <h6>{title}</h6>
      <div style={{ height }}>
        {chartData && <canvas ref={chartRef} style={{height: '100%'}}></canvas>}
        {!chartData && <div className='placeholder' />}
      </div>
    </div>
  )
}